export const UNCATEGORIZED_ID = '__uncategorized__'

// An entry is an LLM checklist item if it uses the llm_prompt trigger type (new style)
// or has an ai_checklist_prompt (legacy style). Descriptions are only valid on these.
export const isLlmChecklistEntry = (entry) =>
  entry?.trigger?.type === 'llm_prompt' || !!entry?.ai_checklist_prompt?.trim()

// Converts flat checklist data into the nested category format used by DP/Post-Call,
// so both can share the same category UI components. Rendering only — redux state stays flat.
export const checklistToCategoryFormat = (checklist) => {
  const {
    order = [],
    entries = {},
    categories = {},
    category_order: categoryOrder = [],
  } = checklist

  // Reverse lookup: item id -> category id
  const itemCategoryLookup = {}
  for (const [categoryId, category] of Object.entries(categories)) {
    for (const itemId of category.order || []) {
      itemCategoryLookup[itemId] = categoryId
    }
  }

  // Bucket item ids by category, collecting leftovers as uncategorized
  const groupedItems = {}
  const uncategorizedOrder = []

  for (const id of order) {
    const categoryId = itemCategoryLookup[id]

    if (categoryId && categories[categoryId]) {
      if (!groupedItems[categoryId]) {
        groupedItems[categoryId] = []
      }
      groupedItems[categoryId].push(id)
    } else {
      uncategorizedOrder.push(id)
    }
  }

  // category_order first, then any orphaned categories not listed in category_order
  const orderedCategoryIds = [...categoryOrder]
  const orderSet = new Set(categoryOrder)

  for (const categoryId of Object.keys(categories)) {
    if (!orderSet.has(categoryId)) {
      orderedCategoryIds.push(categoryId)
    }
  }

  // Build uncategorized entry objects
  const uncategorizedEntries = {}
  for (const id of uncategorizedOrder) {
    uncategorizedEntries[id] = entries[id]
  }

  // Assemble output: uncategorized first, then each named category
  const resultOrder = [UNCATEGORIZED_ID]
  const resultEntries = {
    [UNCATEGORIZED_ID]: {
      name: 'Uncategorized',
      order: uncategorizedOrder,
      entries: uncategorizedEntries,
    },
  }

  for (const categoryId of orderedCategoryIds) {
    if (categories[categoryId]) {
      resultOrder.push(categoryId)

      const itemIds = groupedItems[categoryId] || []
      const categoryEntries = {}
      for (const id of itemIds) {
        categoryEntries[id] = entries[id]
      }

      resultEntries[categoryId] = {
        name: categories[categoryId].name,
        order: itemIds,
        entries: categoryEntries,
      }
    }
  }

  return { order: resultOrder, entries: resultEntries }
}
